import axios from 'axios';
import { message } from 'ant-design-vue'
import i18n from '@/i18n'
import router from '@/router'

// 创建一个 axios 实例
const instance = axios.create({
  baseURL: process.env.VUE_APP_API_URL, // 这里是你的 API 基础 URL
  timeout: 1000000, // 请求超时时间
  headers: {
    'Content-Type': 'application/json',
  },
  maxContentLength: 10000000,  // 设置请求大小限制
  maxBodyLength: 10000000      // 设置请求体大小限制
  // withCredentials: true,
});

// 请求拦截器（可以添加 token 等信息）
instance.interceptors.request.use(
  (config) => {
    // 假设我们要在每个请求头里添加一个 Authorization token
    const token = localStorage.getItem('token'); // 这里你可以根据需求动态获取
    if (token) {
      config.headers['Authorization'] = token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器（处理响应数据，统一格式）
instance.interceptors.response.use(
  (response) => {
    // 统一处理返回的数据
    if (response.data.status) {
      return Promise.reject({
        msg: response.data.msg,
        status: response.data.status,
      })
    }
    return response.data.data; // 假设所有 API 返回的数据都放在 data 字段里
  },
  (error) => {
    // 可以在这里处理错误，例如显示提示信息
    try {
      if (error.response && error.response.data === "Invalid token") {
        router.replace('/auth-login')
        localStorage.removeItem('token')
        return Promise.reject({
          msg: i18n.t('登录已过期，请重新登录')
        })
      }
    } catch (err) {
      console.log(err)
    }
    return Promise.reject(error);
  }
);

// 封装 GET 请求
const get = (url, params = {}) => {
  return instance.get(url, { params });
};

// 封装 POST 请求
const post = (url, data = {}, options = {}) => {
  return instance({
    method: 'POST',
    url,
    data,
    params: data,
    ...options,
    // params: data,
  });
};

export { get, post };